import React from 'react';

function Instructions() {
	  return (
		      <div className="container">
		        <h1>Instructions</h1>
		        <p><strong>Input Section:</strong></p>
		  <ol>
		  <li ><span >Entering the Entity:</span><span > The user can input an entity in two ways:</span></li>
		  <ol>
		  <li ><span >Typing in the entity:&nbsp;</span></li>
		  <ol>
		  <li ><span >If the entity is not found, the following error message will appear: "Unfortunately, no entity matching the subject was found." You will need to enter the correct entity again.</span></li>
		  </ol>
		  <li ><span >Selecting a suggested entity from the 'Woman in Red' frame:&nbsp;</span></li>
		  <ol>
		  <li ><span >Select the occupation from the drop-down menu.&nbsp;</span></li>
		  <li ><span >Then select the "Woman in Red" entity from the drop-down menu.</span></li>
		  </ol>
		  </ol>
		  <li ><span >Selecting Grammatical Gender (if applicable):</span><span > The user can select a grammatical gender from the drop-down menu (Masculine/Feminine/Other).</span></li>
		  <li ><span >Selecting Language:</span><span > Choose one of the languages from the drop-down menu (English/Irish) for the system output.</span></li>
		  <li ><span >Selecting NLG Systems:</span><span > The user can select one or more NLG systems (Baseline Triple Generator/FORGe/LLM - GPT-3.5) to generate text.</span></li>
		  <ol>
		  <li ><span >To select more than one system, press Cmd (on Mac) and Ctrl (on Windows) and use your cursor to select multiple systems.</span></li>
		  <li ><span >To select all systems, click on one system and then press Cmd + A or Ctrl + A.</span></li>
		  </ol>
		  <li ><span >Selecting Triple Source:</span><span > The user can choose one of the triple sources from the drop-down menu (DBpedia Ontology/Wikipedia Infobox/Wikidata). Note: If a "Woman in Red" entity is selected, the triple source must be Wikidata.</span></li>
		  <li ><span >Query the Data Source:</span><span > Once selections are made, click on the "Query Data Source" button.</span></li>
		  </ol>
		  <p><span >&nbsp;</span></p>
		  <p><strong>Output Section:</strong></p>
		  <ol>
		  <li ><span >Viewing Triples:</span><span > A table of triples will appear. You can select or unselect triples using the checkboxes provided. Once you've made your selection, click "Generate" to proceed.</span></li>
		  <li ><span >Generated Text:</span><span > The system(s) will generate text based on the selected triples. If multiple system outputs are available, you can choose the system output you wish to copy or edit.</span></li>
		  <ol>
		  <li ><span >To copy the generated text, click the "Copy" icon (second icon).</span></li>
		  <li ><span >To edit the text, click the "Edit" icon (first icon). After editing, follow step (a) to copy the text.</span></li>
		  <li ><span >The "Open on Wikipedia" button is currently not operational.</span></li>
		  </ol>
		  </ol>
		      </div>
		    );
}

export default Instructions;

